import type {ReactAction} from '@netx/core/bootstrap';
import {faInboxIn} from '@fortawesome/pro-solid-svg-icons';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';

export const cartSavedActionAddToCurrentCartIcon = faInboxIn;

/**
 * Add all assets to current cart
 * @param params
 * @returns Action
 */
export const cartSavedActionAddToCurrentCart = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-add-to-current-cart',
	cb: () => dispatcher.trigger('cart:saved:add:to:current:cart', savedCart?.id),
	enableTest: () => savedCart != null,
	icon: cartSavedActionAddToCurrentCartIcon,
	get label() {
		return CART_SAVED_ACTION_LABELS.ADD_TO_CURRENT_CART;
	},
	...params,
});

export default cartSavedActionAddToCurrentCart;
